// Nationalités (adjectifs féminins) considérées comme "UE / EEE / Suisse" —
// leurs ressortissants n'ont PAS besoin de la vérification préfecture, même
// s'ils ne sont pas Français.
export const EU_EEA_CH_NATIONALITIES = new Set([
  "Française",
  "Allemande", "Autrichienne", "Belge", "Bulgare", "Chypriote", "Croate",
  "Danoise", "Espagnole", "Estonienne", "Finlandaise", "Grecque", "Hongroise",
  "Irlandaise", "Italienne", "Lettonne", "Lituanienne", "Luxembourgeoise",
  "Maltaise", "Néerlandaise", "Polonaise", "Portugaise", "Roumaine", "Slovaque",
  "Slovène", "Suédoise", "Tchèque",
  // EEE
  "Islandaise", "Liechtensteinoise", "Norvégienne",
  // Suisse
  "Suisse",
]);

export function isEuEeaCh(nationality) {
  if (!nationality) return false;
  return EU_EEA_CH_NATIONALITIES.has(nationality.trim());
}
